export interface Drama {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  rating: number;
  year: number;
  episodes: string;
  status: string;
  director: string;
  cast: string[];
  description: string;
  longDescription: string;
  tags: string[];
  posterUrl: string;
  thumbUrl: string;
  isHot: boolean;
  isNew: boolean;
  isTopRated: boolean;
  region: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { name: '韩剧', slug: 'korean', icon: 'ri-vip-crown-line' },
  { name: '美剧', slug: 'american', icon: 'ri-flag-line' },
  { name: '国产剧', slug: 'chinese', icon: 'ri-tv-line' },
  { name: '日剧', slug: 'japanese', icon: 'ri-sun-line' },
  { name: '泰剧', slug: 'thai', icon: 'ri-heart-line' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '黑暗荣耀',
    titleEn: 'The Glory',
    category: '韩剧',
    categorySlug: 'korean',
    rating: 9.1,
    year: 2023,
    episodes: '16集全',
    status: '已完结',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    description: '梦想成为建筑师的文东恩，高中时期因遭受校园暴力而不得不退学，随后她精心策划了一场漫长而隐秘的复仇计划。',
    longDescription: '《黑暗荣耀》讲述了在高中时期遭受残酷校园暴力的文东恩，被迫退学后隐忍多年，精心策划了一场对加害者和旁观者们的复仇计划。她成为了加害者女儿的小学班主任，从此拉开了一场精密而冷酷的复仇大幕。该剧以其深刻的社会批判、出色的剧本和演员的精湛演技获得全球观众的高度评价，成为Netflix全球热播剧集，探讨了校园暴力、阶级差异和人性的复杂面。',
    tags: ['复仇', '悬疑', '校园暴力', 'Netflix'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20The%20Glory%20Korean%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20elegant%20typography%20composition%2C%20cold%20winter%20tone&width=400&height=600&seq=drama-the-glory-korean&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20The%20Glory%20Korean%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-the-glory-korean-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '韩国',
  },
  {
    id: 'drama-2',
    title: '狂飙',
    titleEn: 'The Knockout',
    category: '国产剧',
    categorySlug: 'chinese',
    rating: 9.2,
    year: 2023,
    episodes: '39集全',
    status: '已完结',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    description: '京海市刑警安欣与鱼贩高启强相识，随后高启强逐渐偏离正途，两人展开了长达二十年的正邪较量。',
    longDescription: '《狂飙》以京海市为背景，讲述了刑警安欣与黑恶势力头目高启强之间长达二十年的角力。从最初的普通鱼贩到后来掌控京海市地下秩序的大佬，高启强的转变令人唏嘘。安欣则始终坚守正义，不遗余力地与黑恶势力斗争。该剧以扣人心弦的剧情、立体丰满的人物塑造和深刻的时代反思，成为2023年中国电视剧的现象级作品，引发了广泛的社会讨论，被誉为扫黑题材的巅峰之作。',
    tags: ['刑侦', '扫黑', '悬疑', '现实题材'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20The%20Knockout%20Chinese%20crime%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20gritty%20urban%20tone&width=400&height=600&seq=drama-the-knockout-chinese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20The%20Knockout%20Chinese%20crime%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-the-knockout-chinese-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '中国大陆',
  },
  {
    id: 'drama-3',
    title: '怪奇物语',
    titleEn: 'Stranger Things',
    category: '美剧',
    categorySlug: 'american',
    rating: 8.9,
    year: 2022,
    episodes: '四季34集',
    status: '连载中',
    director: '马特·达菲 / 罗斯·达菲',
    cast: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    description: '20世纪80年代，印第安纳州霍金斯小镇上一名男孩神秘失踪，他的朋友、家人和当地警察开始寻找答案。',
    longDescription: '《怪奇物语》是一部融合科幻、恐怖和青春成长元素的美国电视剧。故事设定在1980年代的印第安纳州霍金斯小镇，一群孩子意外卷入了一个涉及秘密政府实验、超自然力量和异次元世界的巨大阴谋中。神秘的"颠倒世界"与现实世界交织，孩子们必须团结一致，面对来自另一个维度的恐怖威胁。该剧以其复古美学、紧凑叙事和动人的角色关系成为全球文化现象。',
    tags: ['科幻', '恐怖', '青春', 'Netflix'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Stranger%20Things%20sci%20fi%20horror%20series%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20retro%20eighties%20vibe&width=400&height=600&seq=drama-stranger-things-american&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Stranger%20Things%20sci%20fi%20horror%20series%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-stranger-things-american-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '美国',
  },
  {
    id: 'drama-4',
    title: '半泽直树',
    titleEn: 'Hanzawa Naoki',
    category: '日剧',
    categorySlug: 'japanese',
    rating: 9.0,
    year: 2020,
    episodes: '两季20集',
    status: '已完结',
    director: '福泽克雄',
    cast: ['堺雅人', '上户彩', '香川照之', '及川光博'],
    description: '银行职员半泽直树在职场中面对上司的不公和同僚的阴谋，以"加倍奉还"为信念展开反击。',
    longDescription: '《半泽直树》以东京中央银行大阪西分行为舞台，讲述了融资课长半泽直树面对上司的不公正待遇和职场阴谋，凭借着过人的智慧和坚强的信念，一步步揭露真相、还击敌人的故事。剧中"加倍奉还"的经典台词成为社会流行语，展现了日本职场文化的复杂性以及正义必胜的理念。该剧在日本创下惊人收视率，成为平成时代最受欢迎的电视剧之一。',
    tags: ['职场', '金融', '复仇', '热血'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Hanzawa%20Naoki%20Japanese%20business%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20corporate%20tension&width=400&height=600&seq=drama-hanzawa-japanese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Hanzawa%20Naoki%20Japanese%20business%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-hanzawa-japanese-thumb&orientation=portrait',
    isHot: false,
    isNew: false,
    isTopRated: true,
    region: '日本',
  },
  {
    id: 'drama-5',
    title: '以爱为营',
    titleEn: 'Love in the Air',
    category: '泰剧',
    categorySlug: 'thai',
    rating: 7.8,
    year: 2024,
    episodes: '20集全',
    status: '已完结',
    director: '纳塔彭·蒙空萨瓦',
    cast: ['吉拉宇·唐思苏克', '乌拉萨雅·斯帕邦德', '普林·苏帕拉'],
    description: '都市中的精英男女在职场与爱情中交错，上演了一段段甜虐交织的浪漫故事。',
    longDescription: '《以爱为营》是一部融合都市爱情与职场元素的泰剧精品。讲述了金融才女与创业精英之间从针锋相对到相知相爱的故事。两位主角在商场上各展才华，在感情上则经历了从误解到理解、从敌对到爱慕的转变过程。该剧以精美的画面、细腻的情感描绘和高颜值的演员阵容赢得了观众的喜爱，展现了现代都市男女在事业与感情中的成长与抉择。',
    tags: ['爱情', '都市', '职场', '浪漫'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Love%20in%20the%20Air%20Thai%20romance%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20romantic%20soft%20tone&width=400&height=600&seq=drama-love-in-the-air-thai&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Love%20in%20the%20Air%20Thai%20romance%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-love-in-the-air-thai-thumb&orientation=portrait',
    isHot: false,
    isNew: true,
    isTopRated: false,
    region: '泰国',
  },
  {
    id: 'drama-6',
    title: '庆余年',
    titleEn: 'Joy of Life',
    category: '国产剧',
    categorySlug: 'chinese',
    rating: 8.6,
    year: 2019,
    episodes: '两季70集',
    status: '连载中',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    description: '拥有现代记忆的少年范闲穿越到古代庆国，凭借智慧在朝堂与江湖间游走。',
    longDescription: '《庆余年》改编自猫腻同名小说，讲述了拥有现代记忆的范闲穿越到一个架空朝代的庆国，凭借着超越时代的知识和智慧，在波谲云诡的朝堂斗争与江湖纷争中一步步成长。他既要面对皇室内部的权力倾轧，又要探寻母亲离世的真相。该剧融合了权谋、武侠、科幻和喜剧等多种元素，以出色的剧本、精良的制作和全明星阵容获得了极高口碑，成为国产古装剧的标杆之作。',
    tags: ['古装', '权谋', '武侠', '穿越'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Joy%20of%20Life%20Chinese%20historical%20fantasy%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20ancient%20Chinese%20aesthetic&width=400&height=600&seq=drama-joy-of-life-chinese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Joy%20of%20Life%20Chinese%20historical%20fantasy%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-joy-of-life-chinese-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '中国大陆',
  },
  {
    id: 'drama-7',
    title: '摸心第六感',
    titleEn: 'Behind Your Touch',
    category: '韩剧',
    categorySlug: 'korean',
    rating: 8.3,
    year: 2024,
    episodes: '16集全',
    status: '已完结',
    director: '金锡允',
    cast: ['韩志旼', '李民基', '金俊勉'],
    description: '拥有读心术的兽医与热血刑警联手破案，在无厘头的村庄里展开爆笑又悬疑的探案故事。',
    longDescription: '《摸心第六感》是一部融合喜剧、悬疑和奇幻元素的韩剧。故事讲述了在偏远乡村工作的兽医艺芬，在某天意外获得了能够通过摸屁股看到人与动物记忆的超能力。她与从首尔调来的热血刑警将烈联手，利用这一奇特的能力破获了一系列发生在村庄中的神秘案件。该剧以轻松幽默的基调包装了悬疑推理的内核，角色之间的化学反应令人捧腹，同时案件设计也颇具巧思。',
    tags: ['喜剧', '悬疑', '奇幻', '探案'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Behind%20Your%20Touch%20Korean%20comedy%20thriller%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20quirky%20village%20vibe&width=400&height=600&seq=drama-behind-your-touch-korean&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Behind%20Your%20Touch%20Korean%20comedy%20thriller%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-behind-your-touch-korean-thumb&orientation=portrait',
    isHot: false,
    isNew: true,
    isTopRated: false,
    region: '韩国',
  },
  {
    id: 'drama-8',
    title: '三体',
    titleEn: 'Three-Body',
    category: '国产剧',
    categorySlug: 'chinese',
    rating: 8.7,
    year: 2023,
    episodes: '30集全',
    status: '已完结',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    description: '汪淼被卷入到一场关于地球外文明与人类命运的惊世危机中，三体世界的序幕缓缓拉开。',
    longDescription: '《三体》改编自刘慈欣同名科幻巨著，讲述了纳米科学家汪淼在警官史强的协助下，逐步揭开了地球基础科学异常现象背后隐藏的外星文明——三体世界的真相。随着调查深入，地球三体组织ETO的阴影浮出水面，人类文明面临前所未有的挑战。该剧以宏大的宇宙观、深刻的人文思辨和震撼的视觉效果，成功将中国科幻文学的代表作搬上荧屏，引发了广泛的科学讨论和文化热潮。',
    tags: ['科幻', '悬疑', '宇宙', '刘慈欣'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Three%20Body%20Chinese%20sci%20fi%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20cosmic%20mystery%20vibe&width=400&height=600&seq=drama-three-body-chinese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Three%20Body%20Chinese%20sci%20fi%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-three-body-chinese-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '中国大陆',
  },
  {
    id: 'drama-9',
    title: '继承之战',
    titleEn: 'Succession',
    category: '美剧',
    categorySlug: 'american',
    rating: 9.3,
    year: 2023,
    episodes: '四季39集',
    status: '已完结',
    director: '杰西·阿姆斯特朗',
    cast: ['布莱恩·考克斯', '杰瑞米·斯特朗', '莎拉·斯努克', '基南·卡尔金'],
    description: '罗伊家族掌控的全球最大媒体帝国面临继承危机，四兄妹为争夺控制权展开残酷的权力游戏。',
    longDescription: '《继承之战》讲述了传媒大亨罗根·罗伊及其四个子女之间为争夺家族媒体帝国控制权而展开的权力斗争。当罗根的健康状况恶化，谁将继承这个庞大的商业帝国成为所有矛盾的焦点。每个子女都各怀心思，在董事会、股东和家族之间进行复杂的博弈。该剧以犀利的对白、精湛的群像演技和对资本主义权力结构的深刻剖析，获得了艾美奖和金球奖的众多肯定，被誉为当代最佳美剧之一。',
    tags: ['商战', '权谋', '家庭', 'HBO'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Succession%20American%20business%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20luxury%20corporate%20vibe&width=400&height=600&seq=drama-succession-american&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Succession%20American%20business%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-succession-american-thumb&orientation=portrait',
    isHot: false,
    isNew: false,
    isTopRated: true,
    region: '美国',
  },
  {
    id: 'drama-10',
    title: '凪的新生活',
    titleEn: 'Nagis Long Vacation',
    category: '日剧',
    categorySlug: 'japanese',
    rating: 8.5,
    year: 2019,
    episodes: '10集全',
    status: '已完结',
    director: '坪井敏雄',
    cast: ['黑木华', '高桥一生', '中村伦也'],
    description: '28岁的职场女性凪因过呼吸晕倒后，辞去工作、搬离市区，开始了重新寻找自我的新生活。',
    longDescription: '《凪的新生活》改编自同名漫画，讲述了在东京工作的OL大岛凪，因为过度在意他人眼光而身心俱疲，在某次过呼吸发作后，她毅然决然地辞去工作、注销社交账号、清空所有物品，搬到一个简陋的公寓开始了"重启人生"的假期。在这个夏天，她遇到了奇特的邻居们，也开始学会拒绝和做自己。该剧以温暖治愈的基调探讨了现代人的社交焦虑与自我认同，收获了极高的口碑。',
    tags: ['治愈', '职场', '成长', '漫改'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Nagis%20Long%20Vacation%20Japanese%20healing%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20peaceful%20summer%20vibe&width=400&height=600&seq=drama-nagi-japanese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Nagis%20Long%20Vacation%20Japanese%20healing%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-nagi-japanese-thumb&orientation=portrait',
    isHot: false,
    isNew: false,
    isTopRated: false,
    region: '日本',
  },
  {
    id: 'drama-11',
    title: '眼泪女王',
    titleEn: 'Queen of Tears',
    category: '韩剧',
    categorySlug: 'korean',
    rating: 8.8,
    year: 2024,
    episodes: '16集全',
    status: '已完结',
    director: '张英宇',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    description: '财阀千金洪海仁与农村出身的白贤宇结婚三年后，婚姻岌岌可危，却在危机中重新找回爱情。',
    longDescription: '《眼泪女王》讲述了皇后百货的财阀千金洪海仁与农村出身的律师白贤宇结婚三年后，婚姻亮起红灯的故事。海仁意外发现自己身患绝症，而贤宇则在妻子最脆弱的时候重新发现了对她的爱。在生死考验面前，两人重新审视彼此的关系，从即将分崩离析的婚姻中找回了最初的感动与真情。该剧以细腻的情感描写、催泪的剧情发展和金秀贤与金智媛的默契演技成为了现象级韩剧。',
    tags: ['爱情', '财阀', '催泪', '治愈'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Queen%20of%20Tears%20Korean%20romance%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20emotional%20melodrama&width=400&height=600&seq=drama-queen-of-tears-korean&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Queen%20of%20Tears%20Korean%20romance%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-queen-of-tears-korean-thumb&orientation=portrait',
    isHot: true,
    isNew: true,
    isTopRated: true,
    region: '韩国',
  },
  {
    id: 'drama-12',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    category: '国产剧',
    categorySlug: 'chinese',
    rating: 8.9,
    year: 2024,
    episodes: '30集全',
    status: '已完结',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    description: '九十年代的上海，阿宝乘着改革开放的春风崛起于商界，在黄浦江畔书写一段繁华传奇。',
    longDescription: '《繁花》由王家卫执导，改编自金宇澄同名小说，讲述了上世纪九十年代上海滩的跌宕风云。阿宝从平凡的上海青年，乘着改革开放的浪潮在商界打拼崛起，与各路人物在黄河路上演了一幕幕商海沉浮与爱恨纠葛。该剧以王家卫标志性的影像美学、精致考究的时代还原和群星闪耀的演员阵容，生动描绘了上海这座城市在时代巨变中的独特魅力和人间百态。',
    tags: ['商战', '年代', '上海', '王家卫'],
    posterUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Blossoms%20Shanghai%20Chinese%20period%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20nostalgic%20Shanghai%20vibe&width=400&height=600&seq=drama-blossoms-shanghai-chinese&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20for%20Blossoms%20Shanghai%20Chinese%20period%20drama%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20professional%20movie%20poster%20design%2C%20warm%20golden%20accents%20on%20dark%20background&width=160&height=240&seq=drama-blossoms-shanghai-chinese-thumb&orientation=portrait',
    isHot: true,
    isNew: false,
    isTopRated: true,
    region: '中国大陆',
  },
];

export const hotDramas = dramas.filter(d => d.isHot);
export const topRatedDramas = dramas.filter(d => d.isTopRated).sort((a, b) => b.rating - a.rating);
export const newDramas = dramas.filter(d => d.isNew);

export const getDramasByCategory = (slug: string) => {
  if (slug === 'all') return dramas;
  return dramas.filter(d => d.categorySlug === slug);
};

export const getDramaById = (id: string) => {
  return dramas.find(d => d.id === id);
};